import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Heading from '../components/Heading'
import TriRoundRow from '../components/TriRoundRow'
import CenterRow from '../components/CenterRow'
import Divider from '../components/Divider'
import CTAButton from '../components/CTAButton'
import Hero from '../components/Hero'
import AppsAndService from '../components/AppsAndService'
import LeadForm from '../components/LeadForm'

class ServicePage extends React.Component {
  render () {
  	const pages = [ ...this.props.route.pages ]
    const path = this.props.route.page.path

  	const meta = {
  		description: "ACS provides many industrial and power related markets with acoustic cleaners (sonic horns) to solve all their material handling problems. With experience dating back to 1989, ACS has tested methods and proven innovative products that get the job done right. Our products are also direct replacements for all major sonic horn brands making us a clear choice for your repair and upgrade situations.",
  		keywords: "Acoustic Cleaning Systems",
  		headline: "ACS Parts & Service: Spare parts to on site service, your one stop solution shop.",
  		title: "ACS Parts & Service: Spare parts to on site service, your one stop solution shop."
  	}

    return (
      <div className="service-page">
        <Helmet
          title={`${meta.title}`}
          meta={[
            { name: "Description", content: `${meta.description}`},
            { name: "Keywords", content: `${meta.keywords}`},
            { property: "og:title", content: `${meta.headline}`},
            { property: "og:description", content: `${meta.description}`},
            { property: "og:type", content: "article"},
            { property: "og:url", content: `${config.rootUrl}${path}`},
            { name: "twitter:card", content: "summary_large_image"},
            { name: "twitter:site", content: `${config.twitterHandle}` },
            { name: "twitter:creator", content: `${config.twitterHandle}` },
            { name: "twitter:title", content: `${meta.title}` },
            { name: "twitter:description", content: `${meta.description}` }
          ]}
        />
				<Hero headline="Spare Parts, Training, or Consultation we have you covered."
					className="applications"
					images={[
						'/images/hero/1.jpg',
						'/images/hero/0.jpg',
						'/images/hero/2.jpg',
					]}
				>
					<LeadForm />
				</Hero>
				<br /><br />
				<div className="container page installations-page">
					<div className="row center-xs">
						<div className="col-md-4 col-sm-5 col-xs-12 left-col">
							<h2>ACS Compatibility</h2>
							<p>
								We offer direct replacement solutions for most major brands and at attractive prices! Acoustic
								Cleaning Systems offers a broad range of acoustic cleaners along with various mounting
								scenarios and installation options. We can customize units to fit a specific installation or
								material requirement. Contact us for all your spare parts and specialty needs.
							</p>
						</div>
						<div className="col-md-4 col-sm-5 col-xs-12">
							<img style={{margin:'auto'}} src="/images/PM1.jpg" />
							<br /><br />
						</div>
					</div>
					<Divider />
					<div className="row center-xs">
						<div className="col-md-4 col-sm-5 col-xs-12">
							<img style={{margin:'auto'}} src="/images/PM2.jpg" />
						</div>
						<div className="col-md-4 col-sm-5 col-xs-12 right-col">
							<h2>On Site Consulting and Training</h2>
							<p>
								We can visit your site and let you know if your situation is right for acoustic cleaners. We can
								also advise the size, location, and proper mounting configurations of acoustic cleaners at your
								facility.
							</p>
							<p>
								On-site training of plant personnel for existing installations is also something we excel at. This
								service includes maintenance, operation, and troubleshooting training. Call us today to give
								your employees the best training for your specific products and applications.
							</p>
						</div>
					</div>
					<Divider />
					<AppsAndService />
				</div>
    	</div>
    )
  }
}

ServicePage.propTypes = {}
ServicePage.defaultProps = {}
ServicePage.data = {
  menuLabel: 'Parts & Service',
  menuShortDescription: 'Service for Acoustic Cleaning Services, Inc.'
}
export default ServicePage



// WEBPACK FOOTER //
// ./service.js